import { render, staticRenderFns } from "./manufacturingDeposits.vue?vue&type=template&id=60568367"
import script from "./manufacturingDeposits.vue?vue&type=script&lang=js"
export * from "./manufacturingDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports